"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALL_BOOKING_URL = void 0;
exports.CALL_BOOKING_URL = 'https://aven.com/call';
